export default __webpack_public_path__ + "static/mark-7c56412a6f0b0d39aafda499a8e0bca7.jpg";